const host = location.host.indexOf(".gamersky.com") != -1 ? '.gamersky.com' : '';
const utils = {
    urlParam(url, params) {
        let keys = Object.keys(params)
        let strArr = url.split('/')
        let result = ''
        strArr.forEach(i => {
            if (i[0] === ':') {
                keys.forEach(j => {
                    if (j === i.substring(1, i.length)) {
                        i = params[j].toString()
                    }
                })
            }
            result += i + '/'
        })
        return result.substring(0, result.length - 1)
    },
    creatApi(options) {
        let _this = this;
        let result = {};
        let funNames = Object.keys(options);
        funNames.forEach(name => {
            result[name] = obj => {
                const method = options[name][0];
                let url = options[name][1];
                if (obj) {
                    url = this.urlParam(url, obj);
                }
                return ajax[method](url, obj);
            }
        });
        return result;
    },
    AjaxJsonp(url, data = {}) {
        if (!url)
            throw new Error('url is necessary')
        const callback = 'CALLBACK' + Math.random().toString().substr(9, 18)
        const JSONP = document.createElement('script')
        JSONP.setAttribute('type', 'text/javascript')

        const headEle = document.getElementsByTagName('head')[0]
        let ret = '';
        if (data) {
            if (typeof data === 'string')
                ret = '&' + data;
            else if (typeof data === 'object') {
                for (let key in data)
                    ret += '&' + key + '=' + encodeURIComponent(data[key]);
            }
            ret += '&_=' + Date.now();
        }
        JSONP.src = `${url}?callback=${callback}${ret}`;
        return new Promise((resolve, reject) => {
            window[callback] = r => {
                resolve(r)
                headEle.removeChild(JSONP)
                delete window[callback]
            }
            headEle.appendChild(JSONP)
        })
    },
    logincheck() {
        return new Promise((resolve, reject) => {
            utils.AjaxJsonp("//i.gamersky.com/api/logincheck", {}).then(response => {
                if(response != "") {
                    utils.cookie("UserCookie", decodeURIComponent(JSON.stringify(response)), { path: '/', domain: host });
                    resolve();
                }else{
                    reject();
                }
            });
        })
    },
    loginOut: function () {
        utils.AjaxJsonp("//i.gamersky.com/api/userlogout", {}).then(response => {
            utils.removeCookie("UserCookie", {
                path: '/',
                domain: host
            });
            window.location.reload();
        });
    },
    // 浏览器UA判断相关
    browser: {
        /**
         * @description: 是否移动端
         * @author: ADCannon
         * @date: 2021-07-16 11:55:16
         * @version: V1.0.0
         */
        IsMobile: function () {
            let info = navigator.userAgent;
            let agents = ["Android", "iPhone", "SymbianOS", "Windows Phone"];
            for (let i = 0; i < agents.length; i++) {
                if (info.indexOf(agents[i]) >= 0) return true;
            }
            return false;
        },
        /**
         * @description: 是否微信内打开
         * @author: ADCannon
         * @date: 2021-07-16 11:55:35
         * @version: V1.0.0
         */
        isWeiXin: function () {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @description: 是否支付宝内打开
         * @author: ADCannon
         * @date: 2021-07-16 11:55:53
         * @version: V1.0.0
         */
        isAlipay: function () {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/Alipay/i) == "alipay") {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @description: 是否iOS系统
         * @author: ADCannon
         * @date: 2021-07-16 11:58:12
         * @version: V1.0.0
         */
        isiOS: function () {
            var u = navigator.userAgent;
            return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        },
        /**
         * @description: 是否Android系统
         * @author: ADCannon
         * @date: 2021-07-16 11:58:12
         * @version: V1.0.0
         */
        isAndroid: function () {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
            return isAndroid;
        }
    },
    copyUrl(item) {
        // 模拟 输入框
        var cInput = document.createElement("input");
        cInput.value = item;
        document.body.appendChild(cInput);
        cInput.select(); // 选取文本框内容

        // 执行浏览器复制命令
        // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
        // Input要在正常的编辑状态下原生复制方法才会生效

        document.execCommand("copy");

        alert("复制成功");
        // 复制成功后再将构造的标签 移除
        document.body.removeChild(cInput);
    },
    /**
     * 获取/保存 cookie
     * @param key cookie名
     * @param value cookie值，可选，当不传递时，表示根据 cookie 名查找 cookie 值
     * @param options 可配置选项参数，如：{expires:3, path:"/", domain:".baidu.com", secure:true}
     */
     cookie: function (key, value, options) {
        // 未传递 value 参数，则表示读取 cookie
        if (typeof value === "undefined") {
            // 将域下所有 cookie 读取出来，以 "; " 分割保存到数组中
            var cookies = document.cookie.split("; ");
            // 遍历迭代所有的 cookie ，查找指定 key 对应的 cookie 值
            for (var i = 0, len = cookies.length; i < len; i++) {
                // 将当前遍历到的 cookie 使用 "=" 分割
                var parts = cookies[i].split("=");
                // 数组中第一个元素为 cookie 名，将 cookie 名解码
                var name = decodeURIComponent(parts.shift());
                // 判断当前 cookie 名与待查找 cookie 的名称是否一致
                if (name === key) // 找到 cookie，则返回对应 cookie 值
                    return decodeURIComponent(parts.join("="));
            }

            // 如果循环迭代完毕所有 cookie 都不存在要查找的 cookie 信息，则说明未保存过
            return undefined;
        }

        // 传递了 value 参数，表示保存 cookie
        // "key=value"，将 key 和 value 编码
        var _cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value);
        // 判断可配置选项
        options = options || {};
        if (options.expires) { // 有失效时间的配置
            var date = new Date();
            date.setDate(date.getDate() + options.expires);
            _cookie += ";expires=" + date.toUTCString();
        }
        if (options.path) // 有配置路径
            _cookie += ";path=" + options.path;
        if (options.domain){ // 域
            _cookie += ";domain=" + options.domain;
        }else{
            _cookie += ";domain=" + host;
        }
            
        if (options.secure) // 安全链接
            _cookie += ";secure";
        // 保存 cookie
        document.cookie = _cookie;
    },
    /**
     * 删除 cookie
     * @param key cookie名
     * @param options 可配置选项参数，如：{expires:3, path:"/", domain:".baidu.com", secure:true}
     */
    removeCookie: function (key, options) {
        options = options || {};
        options.expires = -1;
        utils.cookie(key, "", options);
    },
};

export default utils;